const middlewares = [];

export const addMiddleware = (...added) => {
  middlewares.push(...added);
};

export const removeMiddleware = (middleware) => {
  const index = middlewares.indexOf(middleware);
  if (index !== -1) middlewares.splice(index, 1);
};

export const resetMiddlewares = () => {
  middlewares.length = 0;
};

const dynamicMiddleware = (storeAPI) => (next) => (action) => {
  if (middlewares.length === 0) return next(action);
  const chain = middlewares.map((mw) => mw(storeAPI));
  const composed = chain.reduceRight((n, mw) => mw(n), next);
  return composed(action);
};

export default dynamicMiddleware;
